import React from "react";
import { Avatar } from "antd";
import CandidateAvatarIcon from "./CandidateAvatarIcon";

function CandidateAvatar() {
  return (
    <>
      <Avatar icon={<CandidateAvatarIcon />}  />
    </>
  );
}

export default CandidateAvatar;
